module.exports = __webpack_public_path__ + "img/权限2.86adf263.svg";